module.exports = __webpack_public_path__ + "static/seoImage-ccb2b45414065db7acccfd2f0fe66411.png";